import React, { useContext, useEffect, useState, useMemo } from "react";
import classes from "./App.module.scss";
import "./OverrideLibs.scss";
import "./App.module.scss";
import "bootstrap-4-grid/scss/grid.scss";
import Layout from "./hoc/Layout";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import * as r from "./constants/routes";
import * as api from "./constants/api";
import awsConfig from "./aws-exports";
import { Amplify } from "aws-amplify";
import * as Auth from "@aws-amplify/auth";
import SessionContext, {
  SessionInterface,
  // UserInterface
} from "./context/sessionContext";
// main components
import _uLogin from "./containers/User/Login";
import _aLogin from "./containers/Admin/Login";
import _uLoginHome from "./containers/LoginAccess/LoginHome/index"
import _aPasswordRecovery from "./containers/Admin/Login/PasswordRecovery";
import LoginContext from "./context/loginContext";
import { UserTrainingProvider } from "./context/userTrainingContext";
import { checkValidStringDate } from "./helpers";
import ReactPixel, { AdvancedMatching, Options } from "react-facebook-pixel";
import { GET_PROD_OR_DEV } from "./constants/api";
import { PROD } from "./constants/defaults";
import _uWelcome from "./containers/SmartUser/Tutorials/Welcome";
import _uHome from "./containers/User/Home";
import _uFirstEval from "./containers/SmartUser/Home";
import _uTCategory from "./containers/User/Training/GamesList";
import _uTGameScreen from "./containers/User/Training/GamesScreen";
import _uTests from "./containers/SmartUser/Tests/ListTests";
import _uActiveTest from "./containers/SmartUser/Tests/Test";
import _uUpdateBirthdate from "./containers/User/Settings/UpdateBirthdate";
import _aDashboard from "./containers/Admin/Dashboard";
import _aStore from "./containers/Admin/Store";
import _aPurchaseHistory from "./containers/Admin/PurchaseHistory";
import _aFiltersDashboard from "./containers/Admin/FiltersDashboard";
import _aUserList from "./containers/Admin/Users/User/List";
import _aAdminListSmart from "./containers/Admin/Users/User/ListSmart";
import _aUserAdd from "./containers/Admin/Users/User/AddGo";
import _aUserAddSmart from "./containers/Admin/Users/User/AddSmart";
import _aUserRemove from "./containers/Admin/Users/User/Remove";
import _aAdminList from "./containers/Admin/Users/Admin/List";
import _aAdminAdd from "./containers/Admin/Users/Admin/Add";
import _aAdminReport from "./containers/Admin/Users/User/Report";
import _aAdminReportSmart from "./containers/Admin/Users/User/ReportSmart";
import _aFirstPW from "./containers/Admin/Settings/FirstPW";
import _aUpdatePW from "./containers/Admin/Settings/UpdatePW";
import TabUserReports from "./containers/SmartUser/Home/TabUserReports";

const isProd = String(GET_PROD_OR_DEV) === String(PROD);

try {
  if (isProd && window.location.protocol !== "https:") {
    window.location.replace(
      `https:${window.location.href.substring(window.location.protocol.length)}`
    );
  }
} catch (error) {
  console.error("[error to set HTTPS] ", error);
}

Amplify.configure(awsConfig);
// --------- Google Analytics ----------
// const GA_CODE = api.GOOGLE_ANALYTICS;

// --------- Google Analytics ----------

// --------- Amplify ----------
const advancedMatching = {} as AdvancedMatching; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig
  // debug: true, // enable logs
} as Options;

// -----------------------------------------------------
// ========== Pixel ====================================
// -----------------------------------------------------
// const ReactPixel = require("react-facebook-pixel");
// ReactPixel.default.init(api.PIXEL_ID, advancedMatching, options);
try {
  ReactPixel.init(api.PIXEL_ID, advancedMatching, options);
  ReactPixel.pageView();
} catch (error) {
  console.error("[pixel]", error);
}

const App = () => {
  const cSession: SessionInterface = useContext(SessionContext);
  const cLogin = useContext(LoginContext);
  // only to refresh the page

  useEffect(() => { }, [cLogin.first_access_res]);
  useEffect(() => { }, [cSession.is_session_active, cSession.admin]);
  useEffect(() => { }, [cSession.user]);
  const [attributes, set_attributes] = useState(false);
  const [isLoadingattributes, set_isLoadingattributes] = useState(false);
  useEffect(() => {
    try {
      set_isLoadingattributes(true);
      if (cSession.company_uid === undefined) Auth.fetchAuthSession().then(session => session.userSub ?
        Auth.fetchUserAttributes().then((attributes: any) => {
          set_attributes(!!attributes);
          set_isLoadingattributes(false);
          cSession.setAdminUser(attributes);
        }) : set_isLoadingattributes(false)
      );
    } catch (error: any) {
      console.warn("[Login usuário não Admin]");
    }
  }, [cSession]);
  const [hasSession, setHasSession] = useState(() => {
    const storedSession = localStorage.getItem("hasSession");
    return storedSession ? JSON.parse(storedSession) : cSession.is_session_active;
  });
  useEffect(() => {
    const sessionActive = cSession.is_session_active;
    setHasSession(sessionActive);

    // Salvar o estado no localStorage
    localStorage.setItem("hasSession", JSON.stringify(sessionActive));
  }, [cSession.is_session_active]);

  const journey_code = cSession.user?.journey_code ?? null;
  const isAdminFirstPW = cLogin.first_access_res;
  let isAdmin = false;
  let isUserGo = false;
  let isUserSmart = false;
  const { is_manager: isManager } = cSession.admin ?? {};
  let request_birthdate = false;
  const check_first_avaliation = false;
  let request_first_avaliation = false;
  const check_second_avaliation = false;
  let request_second_avaliation = false;
  const userPermission = cSession.user?.user_permission ?? {};
  if (hasSession) {
    if (cSession.is_admin) isAdmin = true;
    else if (cSession.is_user && cSession.user) {
      if (!checkValidStringDate(cSession.user.birthdate))
        request_birthdate = true;
      else if (check_first_avaliation && userPermission === '10') // "10" smart!!!
        request_first_avaliation = true;
      else if (check_second_avaliation && userPermission === '10') // "10" smart!!!
        request_second_avaliation = true;
      else if (userPermission === '01') isUserGo = true;
      else if (userPermission === '10') isUserSmart = true;
    }
  }

  let _routes = (
    <Routes>
      {/* USER ------------------------------------------------ */}
      {request_birthdate && (
        <Route path={r.R_U_REQUEST_BIRTHDATE} element={<_uUpdateBirthdate />} />
      )}
      {(isUserGo || isUserSmart) && (
        <Route path={r.R_U_WELCOME} element={<_uWelcome />} />
      )}
      {(isUserGo || isUserSmart) && (
        <Route path={r.R_U_TRAIN_GAME_SCREEN} element={<_uTGameScreen />} />
      )}
      {(isUserGo || isUserSmart) && (
        <Route path={r.R_U_TRAIN_CAT} element={<_uTCategory />} />
      )}
      {(isUserGo || isUserSmart) && (
        <Route path={r.R_U_TRAIN_CAT_SMART} element={<_uTCategory />} />
      )}
      {isUserGo && !isUserSmart && (
        <Route path={r.R_U_HOME} element={<_uHome />} />
      )}
      {!isUserGo && isUserSmart && (
        <Route path={r.R_SU_HOME} element={<_uFirstEval />} />
      )}
      {(isUserGo || isUserSmart) && (
        <Route path={r.R_U_UPDATE_BIRTHDATE} element={<_uUpdateBirthdate />} />
      )}
      {isUserGo && !isUserSmart && (
        <Route path={r.R_U_ROOT} element={<_uHome />} />
      )}
      {(isUserSmart || request_first_avaliation || isAdmin) && (
        <Route path={r.R_U_TESTS} element={<_uTests />} />
      )}
      {(isUserSmart || request_first_avaliation || isAdmin) && (
        <Route path={r.R_U_ACTIVE_TEST} element={<_uActiveTest />} />
      )}
      
      {(isUserGo || isUserSmart) && (
        <Route path="/relatorio" element={<TabUserReports />} />
      )}
      
      {(isUserGo || isUserSmart) && (
        <Route path="/home" element={isUserSmart ? <_uFirstEval /> : <_uHome />} />
      )}

      {/* MANAGER ------------------------------------------------ */}
      {isAdmin && <Route path="/compras" element={<_aStore />} />}
      {isAdmin && <Route path="/historico-compras" element={<_aPurchaseHistory />} />}
      {/* ADMIN  ------------------------------------------------ */}
      {isAdminFirstPW && <Route path={r.R_A_FIRST_PW} element={<_aFirstPW />} />}
      {isAdmin && <Route path={r.R_A_USERS_LIST} element={<_aUserList />} />}
      {isAdmin && (
        <Route path={r.R_A_USERS_LIST_SMART} element={<_aAdminListSmart />} />
      )}
      {isAdmin && (
        <Route path={r.R_A_FILTERS_DASHBOARD} element={<_aFiltersDashboard />} />
      )}
      {isAdmin && <Route path={r.R_A_USERS_ADD_GO} element={<_aUserAdd />} />}
      {isAdmin && (
        <Route path={r.R_A_USERS_ADD_SMART} element={<_aUserAddSmart />} />
      )}
      {isAdmin && <Route path={r.R_A_REPORT} element={<_aAdminReport />} />}
      {isAdmin && <Route path={r.R_A_REPORT_ANY} element={<_aAdminReport />} />}
      {isAdmin && (
        <Route path={r.R_A_REPORT_SMART} element={<_aAdminReportSmart />} />
      )}
      {isAdmin && <Route path={r.R_A_USERS_OFF} element={<_aUserRemove />} />}
      {isAdmin && <Route path={r.R_A_USERS_OFF_GO} element={<_aUserRemove />} />}
      {isAdmin && <Route path={r.R_A_USERS_OFF_SMART} element={<_aUserRemove />} />}
      {isAdmin && <Route path={r.R_A_PRO_LIST} element={<_aAdminList />} />}
      {isAdmin && isManager && (
        <Route path={r.R_A_PRO_ADD} element={<_aAdminAdd />} />
      )}
      {isAdmin && <Route path={r.R_A_UPDATE_PW} element={<_aUpdatePW />} />}
      {isAdmin && <Route path={"/"} element={<_aDashboard />} />}
      {isAdmin && <Route path={r.R_A_HOME} element={<_aDashboard />} />}
      {isAdmin && <Route path={r.R_A_ROOT} element={<_aDashboard />} />}

      {/* LOGINS ADMIN ---------------------------------------------------- */}
      {!hasSession && <Route path={r.R_A_LOGIN} element={<_aLogin />} />}
      {!hasSession && (
        <Route
          path={r.R_A_PASSWORD_RECOVERY}
          element={<_aPasswordRecovery />}
        />
      )}
      {!hasSession && <Route path={r.R_A_ROOT} element={<_aLogin />} />}
      {/* LOGINS USER ---------------------------------------------------- */}
      {!hasSession && <Route path={r.R_U_LOGIN} element={<_uLogin />} />}
      {/* LOGINS ACCESS--------------------------------------------------- */}
      {!hasSession && <Route path={r.R_U_ROOT} element={<_uLoginHome />} />}

      {/* REDIRECT  ------------------------------------------------ */}
      {isAdmin && <Route path="*" element={<_aDashboard />} />}
      {isUserSmart && journey_code === 1 && <Route path="*" element={<_uFirstEval />} />}
      {isUserSmart && <Route path="*" element={<_uWelcome />} />}
      {isUserGo && <Route path="*" element={<_uTGameScreen />} />}
      {/* {!cSession?.is_session_active && <Route path={"*"} element={<_uLogin />} />} */}
    </Routes>
  );

  _routes = (
    <Router basename="/">
      <Layout className={classes.App}>{_routes}</Layout>
    </Router>
  );
  if (isUserGo || isUserSmart) _routes = <UserTrainingProvider>{_routes}</UserTrainingProvider>;
  return <React.Fragment>{_routes}</React.Fragment>;
};

export default App;